/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

// MODULES //

import config from 'config';


// MAIN //

/**
* Application routes.
*
* @private
* @constant
* @type {Object}
*/
const routes = {
	'VERSION_DEFAULT': config.mount+':version',

	'SEARCH': config.mount+':version/search',
	'HELP': config.mount+':version/help',
	'NONPACKAGE_DEFAULT': config.mount+':version/*',

	'PACKAGE_DEFAULT': config.mount+':version/@stdlib/:pkg+',
	'PACKAGE_INDEX': config.mount+':version/@stdlib/:pkg+/index.html',
	'PACKAGE_BENCHMARKS': config.mount+':version/@stdlib/:pkg+/benchmarks',
	'PACKAGE_TESTS': config.mount+':version/@stdlib/:pkg+/tests',

	'ERROR_DECODER_DEFAULT': config.mount+':version/error/decoder',
	'ERROR_DECODER': config.mount+':version/error/decoder/:code'
};


// EXPORTS //

export default routes;
